import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * 🔗 本地化連結組件
 * 自動為內部連結添加語言前綴
 */
const LocalizedLink = ({ to, children, ...props }) => {
  const { language } = useLanguage();
  
  // 外部連結直接返回
  if (typeof to === 'string' && (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:'))) {
    return <Link to={to} {...props}>{children}</Link>;
  }
  
  // 處理內部連結
  let localizedTo = to;
  
  if (typeof to === 'string') {
    // 移除開頭的 /
    const cleanPath = to.startsWith('/') ? to.slice(1) : to;
    
    // 檢查是否已經有語言前綴
    const hasLangPrefix = /^(en|zh|ja)(\/|$)/.test(cleanPath);
    
    if (hasLangPrefix) {
      // 已有語言前綴，直接使用
      localizedTo = `/${cleanPath}`;
    } else {
      // 沒有語言前綴，添加當前語言
      localizedTo = cleanPath ? `/${language}/${cleanPath}` : `/${language}`;
    }
  }
  
  return <Link to={localizedTo} {...props}>{children}</Link>;
};

export default LocalizedLink;